import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { ModalModule } from "ngx-bootstrap/modal";
import { NgModule, ModuleWithProviders } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { MatTableModule } from "@angular/material/table";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatSortModule } from "@angular/material/sort";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { TimepickerModule } from "ngx-bootstrap/timepicker";

import { SalesManagerOrdersComponent } from "./salesmanagerorders.component";
import { SalesManagerOrdersService, SalesManagerOrderConfigService, ISalesManagerOrderConfigService } from "./salesmanagerorders.service";
import { TranslateModule } from "@ngx-translate/core";
import { OAuthModule } from "@impacgroup/angular-oauth-base";
import { Route, RouterModule } from "@angular/router";
import { SalesManagerOrdersMainComponent } from "./salesmanagerorders.main.component";
import { SalesManagerOrderDetailComponent } from "./salesmanagerorderdetail.component";

@NgModule({
    declarations: [SalesManagerOrdersMainComponent, SalesManagerOrdersComponent, SalesManagerOrderDetailComponent],
    imports: [
        CommonModule,
        RouterModule,
        FormsModule,
        BsDropdownModule,
        ModalModule,
        NgSelectModule,
        TranslateModule,
        OAuthModule,
        BsDatepickerModule.forRoot(),
        TimepickerModule.forRoot(),
        ReactiveFormsModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatFormFieldModule,
        MatInputModule
    ],
    exports: [],
    providers: []
})
export class SalesManagerOrdersModule {
    static forRoot(salesManagerOrderConfig: ISalesManagerOrderConfigService): ModuleWithProviders<SalesManagerOrdersModule> {
        // returns the services as singletons throughout the app (for lazy loading purposes)
        return {
            ngModule: SalesManagerOrdersModule,
            providers: [
                SalesManagerOrdersService,
                {
                    provide: SalesManagerOrderConfigService,
                    useValue: salesManagerOrderConfig
                }
            ]
        };
    }

    static getRoutes(): Route[] {
        return [
            {
                path: "",
                component: SalesManagerOrdersMainComponent,
                children: [
                    {
                        path: "",
                        component: SalesManagerOrdersComponent
                    },
                    {
                        path: ":id",
                        component: SalesManagerOrderDetailComponent
                    }
                ]
            }
        ];
    }
}
